import styled from 'styled-components';
import SVG from 'assets/svgs';
import { fontMContrast } from 'styles/jakarta';
import { fontM, fontXS } from 'styles/typography';

export type ModalHeaderProps = {
  title: string;
  backOnClick?: () => void;
  closeOnClick?: () => void;
  location?: 'login' | 'transactions' | undefined;
  locationNavigation?: () => void;
  useNewFont?: boolean;
};

const HeaderWrapper = styled.div`
  padding: 16px;
  background-color: ${({ theme }) => theme.surface};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.divisions};
`;

const ModalTitle = styled.h1<{ useNewFont: boolean }>`
  margin: 0;
  color: ${({ theme }) => theme.content};
  ${({ useNewFont }) => (useNewFont ? fontMContrast : fontM)};
  font-weight: 900;
`;

const BackButtonIcon = styled(SVG)`
  margin-right: 16px;
  fill: ${({ theme }) => theme.icon.primary};
  height: 20px;
  width: 20px;
  cursor: pointer;
`;

const CloseButtonIcon = styled(SVG)`
  fill: ${({ theme }) => theme.icon.primary};
  cursor: pointer;
`;

const BackAndTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const AddFundsButton = styled.button`
  background-color: ${({ theme }) => theme.success.background};
  color: ${({ theme }) => theme.success.text};
  border: none;
  padding: 4.5px 12px;
  border-radius: 24px;
  ${fontXS};
  font-family: 'Jost';
  cursor: pointer;
`;

const locationStrategy = {
  login: ({ locationNavigation }) => (
    <AddFundsButton onClick={locationNavigation}>Log in</AddFundsButton>
  ),
  transactions: ({ locationNavigation }) => (
    <AddFundsButton onClick={locationNavigation}>Add funds</AddFundsButton>
  ),
};

const ModalHeader = ({
  title,
  backOnClick,
  closeOnClick,
  location,
  locationNavigation,
  useNewFont,
}: ModalHeaderProps): JSX.Element => (
  <HeaderWrapper>
    <BackAndTitleWrapper>
      {backOnClick && (
        <BackButtonIcon
          data-testid="modal-header-back-button"
          onClick={backOnClick}
          icon="action:chevronLeft"
        />
      )}
      <ModalTitle useNewFont={useNewFont}>{title}</ModalTitle>
    </BackAndTitleWrapper>
    {closeOnClick && (
      <CloseButtonIcon
        data-testid="modal-header-close-button"
        width="20px"
        height="20px"
        onClick={closeOnClick}
        icon="action:close"
      />
    )}
    {location && locationStrategy[location]({ locationNavigation })}
  </HeaderWrapper>
);

export default ModalHeader;
